import {
  Checkbox,
  Divider,
  InlineGrid,
  Select,
  Text,
  TextField,
} from "@shopify/polaris";
import React from "react";
import {
  ageOptions,
  conditionOptions,
  genderOptions,
  sizeSystemOptions,
  sizeTypeOptions,
  unitOptions,
} from "../../utils/constants";

const ProductCharacteristics = ({
  data,
  handleProductCharacteristicsChange,
  handleAdultOrientedChange,
}) => {
  return (
    <>
      <InlineGrid columns={["oneThird", "twoThirds"]}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "15px",
            paddingLeft: "30px",
            paddingTop: "20px",
            paddingBottom: "20px",
            width: "25vw",
          }}
        >
          <Text variant="headingLg" fontWeight="semibold">
            Detailed Product Characteristics
          </Text>
          <Text as="p">
            These attributes are used to submit particular product
            characteristics that users commonly search for. The attributes can
            help you control your ad's appearance when you advertise products.
            These attributes are also used to help potential customers filter by
            attributes.
          </Text>
        </div>
        <div style={{ paddingTop: "10px", paddingBottom: "20px" }}>
          <InlineGrid columns={2}>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                rowGap: "5px",
                paddingBottom: "30px",
              }}
            >
              <Select
                id="condition"
                label="Condition"
                options={conditionOptions}
                onChange={handleProductCharacteristicsChange}
                value={data?.condition}
              />
              <Select
                id="gender"
                label="Gender"
                options={genderOptions}
                onChange={handleProductCharacteristicsChange}
                value={data?.gender}
              />
            </div>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                rowGap: "5px",
              }}
            >
              <Select
                id="ageGroup"
                label="Age Group"
                options={ageOptions}
                onChange={handleProductCharacteristicsChange}
                value={data?.ageGroup}
              />
            </div>
          </InlineGrid>
          <Divider />
          <InlineGrid columns={2}>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                paddingTop: "10px",
                paddingBottom: "20px",
                rowGap: "5px",
              }}
            >
              <Select
                id="sizeSystem"
                label="Size System"
                options={sizeSystemOptions}
                onChange={handleProductCharacteristicsChange}
                value={data?.sizeSystem}
              />
              <TextField
                id="unitPricingMeasure"
                label="Unit Pricing Measure"
                type="integer"
                value={data?.unitPricingMeasure}
                onChange={handleProductCharacteristicsChange}
                autoComplete="off"
                connectedRight={
                  <Select
                    id="unitPricingUnit"
                    value={data?.unitPricingUnit}
                    label="Weight unit"
                    onChange={handleProductCharacteristicsChange}
                    labelHidden
                    options={unitOptions}
                  />
                }
              />
            </div>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                paddingTop: "10px",
                rowGap: "5px",
                paddingBottom: "20px",
              }}
            >
              <Select
                id="sizeType"
                label="Size Type"
                options={sizeTypeOptions}
                onChange={handleProductCharacteristicsChange}
                value={data?.sizeType}
              />
              <TextField
                id="unitPricingBaseMeasure"
                label="Unit Pricing Base Measure"
                type="integer"
                value={data?.unitPricingBaseMeasure}
                onChange={handleProductCharacteristicsChange}
                autoComplete="off"
                connectedRight={
                  <Select
                    id="unitPricingBaseUnit"
                    value={data?.unitPricingBaseUnit}
                    label="Weight unit"
                    onChange={handleProductCharacteristicsChange}
                    labelHidden
                    options={unitOptions}
                  />
                }
              />
            </div>
          </InlineGrid>
          <Divider />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Checkbox
              id="adultOrientedChecked"
              label={
                <>
                  Check this option, if Product is{" "}
                  <strong>Adult-oriented</strong>
                </>
              }
              helpText="Use this to indicate that this product is Adult-oriented because they contain adult merchandise or sexually explicit content such as nudity, sexually suggestive content, or are intended to enhance sexual activity."
              checked={data?.adultOrientedChecked}
              onChange={handleAdultOrientedChange}
            />
          </div>
        </div>
      </InlineGrid>
      <Divider />
    </>
  );
};

export default ProductCharacteristics;
